import { useOutletContext, useSearchParams } from '@remix-run/react';
import { useCallback, useState } from 'react';

import type { OutletContext } from '~/interfaces/outlet_context';

const useCreateStripePriceSession = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { cookies, cookiesSet } = useOutletContext<OutletContext>();

  const mutateAsync = useCallback(
    async (priceId: string, email?: string, premiumOfferId?: string, isCollectingBillingAddress?: boolean) => {
      setIsLoading(true);

      try {
        const params = new URLSearchParams(searchParams);
        params.set('price_id', priceId);

        if (email) {
          params.set('email', email);
        }

        if (premiumOfferId) {
          params.set('offer_id', premiumOfferId);
        }

        if (cookiesSet && cookies.last_resource_guid && !searchParams.get('last_resource_guid')) {
          params.set('last_resource_guid', cookies.last_resource_guid);
        }

        if (isCollectingBillingAddress) {
          params.set('collect_billing_address', 'true');
        }

        const response = await fetch(`/stripe_session?${params}`);
        const body = await response.json();
        return body.session_id;
      } catch {
        // do nothing
      } finally {
        setIsLoading(false);
      }
    },
    [cookies, cookiesSet, searchParams],
  );

  return {
    mutateAsync,
    isLoading,
  };
};

export default useCreateStripePriceSession;
